<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shield-account</v-icon> <span>Registo de Feature</span>
        </h1>
  
        <div class="mt-16">
          <feature method="create"></feature>
        </div>
    </section>
  </template>
  <script>
  import Feature from '@/components/features/Feature'
  
  export default {
    components: {
        Feature
    },
    beforeCreate(){
      document.title = "Hefesto - Registo de Features";
    },
    data: () => ({
      
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "features.create"])) {
        this.$router.push('/admin');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Gestão Features',
            disabled: false,
            to: '/admin/settings/features',
            exact: true,
          },
          {
            text: 'Registo de Features',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  